import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "./NegotiationsBarDetails.css";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Loading from '../../loading/Loading'
import NegotiationBarMessages from "../NegotiationBarMessages/NegotiationBarMessages";
import axios from "axios";
import { format } from 'date-fns';
import { useForm, Controller } from "react-hook-form";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

function NegotiationsBarDetails({ negotiationID, setSelected, setFormClass, proposal, currentProposalUID }) {
	const userUID = useSelector(state => state.user.uid);
	const [confirmed, setConfirmed] = useState(false);
	const [message, setMessage] = useState("");
	const [item, setItem] = useState({});
	const [loading, setLoading] = useState(true);
	const [messagesList, setMessagesList] = useState([]);
	const [disabled, setDisabled] = useState(true);
	const [acceptButtonStyle, setAcceptButtonStyle] = useState("Third")
	const navigate = useNavigate();
	const showTime = format(new Date(), 'MMddyyyyHis');
	const [proposalu, setProposalUp] = useState("");

	const {
		control,
		register,
		handleSubmit,
		formState: { errors },
		getValues,
		reset
	} = useForm();


	async function sendMessage(event) {
		if (message !== '') {
			if (event) {
				event.preventDefault()
			}

			try {
				const paameters2 = {
					action: 'AddNegotiationsMeta',
					negotiation_id: negotiationID,
					message: message,
					UID: userUID,
					proposal: false,

				};
				await axios.post(`${process.env.REACT_APP_API_URL}`, paameters2)
					.then(response => {
						console.log([response.data.data], message)
						setMessagesList(prev => ({
							...prev,
							[response.data.negotiationmeta]: response.data.data
						}));
					})
					.catch(error => {
						Swal.fire({
							icon: 'error',
							title: 'Oops...',
							text: `Something went wrong creating the negotiation${error}`,
						})
					});
				setMessage("");
			} catch (error) {
				console.log(error);
				throw (error)
			}
		}
	}

	function handleInputChange(e) {
		const { value } = e.target;
		setMessage(value);
	}

	function handleMakeOfferButton() {
		Swal.fire({
			title: "Make a proposal",
			input: "number",
			text: `Note: You can use the up and down arrows to change the value`,
			showCancelButton: true,
			inputValue: proposalu,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			cancelButtonText: "Cancel",
			confirmButtonText: "Propose!"
		}).then(result => {
			// debugger
			if (result.value) {
				Swal.fire({
					title: 'Saving, please wait',
					html:
						'<div class="loadingio-spinner-rolling-w23e05eix9"><div class="ldio-ik6pzj2wupc"><div></div></div></div>',
					showConfirmButton: false,
					showCancelButton: false,
					focusConfirm: false,
				});
				if (proposalu.toString() !== result.value) {
					axios.post(`${process.env.REACT_APP_API_URL}`, {
						action: 'AcceptNegotions',
						id: negotiationID,
						currentProposal: parseInt(result.value),
						currentProposalUID: userUID
					}).then(response => {
						if (response.data.status === true) {
							const paameters2 = {
								action: 'AddNegotiationsMeta',
								negotiation_id: negotiationID,
								message: `I propose: $${result.value}`,
								UID: userUID,
								proposal: true,
							};
							axios.post(`${process.env.REACT_APP_API_URL}`, paameters2).then(response => {
								setMessagesList(prev => ({
									...prev,
									[response.data.negotiationmeta]: response.data.data
								}));

								setItem(prevState => ({
									...prevState,
									negotiation: {
										...prevState.negotiation,
										currentProposal: parseInt(result.value)
									}
								}));
								Swal.fire({
									icon: "success",
									title: "Proposal Submited",
									text: `Wait until the other part check the proposal`
								});

								getGarage();
							})
								.catch(error => {
									Swal.fire({
										icon: "error",
										title: "Error",
										text: `We have an error procesing the information. Please try again.`
									});
								});
						} else {
							Swal.fire({
								icon: "error",
								title: "Error",
								text: response.data.message
							});
						}

					})
						.catch(error => {
							console.log(error)
						});
				} else {
					Swal.fire({
						icon: "error",
						title: "Same proposal ",
						text: `The proposal have to be different than the last one`
					});
				}
			}
		});
	}

	const handleAcceptButton = (event) => {
		event.preventDefault();
		document.getElementById('pdfPreviewModalTwo').classList.add('show');
		document.getElementById('pdfPreviewModalTwo').style.display = 'block';
	};

	const closePDFTwoModal = () => {
		document.getElementById('pdfPreviewModalTwo').classList.remove('show');
		document.getElementById('pdfPreviewModalTwo').style.display = 'none';
	};

	const [endDate, setEndDate] = useState();
	const [messageendDate, setMessageendDate] = useState();

	const handleChange = () => {
		const noofmonths = getValues("noofmonths");
		const startdateStr = getValues("startdate");

		if (!startdateStr || startdateStr === '0000-00-00' || isNaN(Date.parse(startdateStr))) {
			console.error('Invalid start date:', startdateStr);
			return;
		}

		const startdate = new Date(startdateStr);

		if (noofmonths > 0 && noofmonths <= 36) {
			const newDate = new Date(startdate);
			newDate.setMonth(newDate.getMonth() + parseInt(noofmonths, 10));

			setEndDate(newDate);
			setMessageendDate(`Garage end date will be ${format(newDate, 'MM/dd/yyyy')}`);
		}
	}


	const onSubmit = (data) => {

		Swal.fire({
			title: 'Saving, please wait',
			html:
				'<div class="loadingio-spinner-rolling-w23e05eix9"><div class="ldio-ik6pzj2wupc"><div></div></div></div>',
			showConfirmButton: false,
			showCancelButton: false,
			focusConfirm: false,
		});


		axios.post(`${process.env.REACT_APP_API_URL}`, {
			action: 'AcceptNegotions',
			dealClosed: 1,
			startdate: data.startdate,
			enddate: endDate,
			noofmonths: data.noofmonths,
			id: negotiationID
		})
			.then(response => {
				if (response)
					Swal.fire({
						icon: "success",
						title: "Negotiation Concluded",
						text: response.data.message
					}).then(() => {
						navigate('/leaseform/' + negotiationID);
						window.location.reload();
					})
			})
			.catch(error => {
				Swal.fire({
					icon: "error",
					title: "Error",
					text: `We have an error procesing the information. Please try again.`
				});
			});
	}


	function handleMakeCheckButton() {
		navigate(`/garages-details/${item.negotiation.garageID}`);
		setFormClass(prev => (prev === "" ? "negotiationExpanded" : ""));
		setSelected(false);
	}

	function onClickSeeDetails() {
		console.log("clickDetails");
		if (item.negotiation.ownerID === userUID) {
			navigate("/view-contract")
			setFormClass(prev => (prev === "" ? "negotiationExpanded" : ""));
			setSelected(false);
		} else {
			navigate("/view-contract")
			setFormClass(prev => (prev === "" ? "negotiationExpanded" : ""));
			setSelected(false);
		}
	}



	// debugger;
	async function getGarage() {
		try {
			setLoading(true);
			// console.log('negotiationID', negotiationID);

			const negotiation = await axios.post(`${process.env.REACT_APP_API_URL}`, {
				action: 'GetNegotiations_byID',
				id: negotiationID,
			})
				.then(response => {
					if (response.data.data.currentProposal !== proposalu) {
						setProposalUp(response.data.data.currentProposal);
					}

					return response.data.data;
				})
				.catch(error => {
					console.log(error)
				});
			//console.log('negotiation', negotiation)
			const data = await axios.post(`${process.env.REACT_APP_API_URL}`, {
				action: 'GetGaragebyId',
				id: negotiation.garageID,
			})
				.then(response => {
					//console.log(response.data.data);
					return response.data.data;
				})
				.catch(error => {
					console.log(error)
				});

			const urlsArray = data.garagePictures;
			const garagePicturesA = data.garagePicturesA ? data.garagePicturesA : '';
			let imagesURL = [];
			if (urlsArray.length>0) {

				for (const image in urlsArray) {
					imagesURL = [...imagesURL, process.env.REACT_APP_UPLOAD_URL + urlsArray[image]];
				}
			} else {
				imagesURL = ['./assets/Images/garage-placeholder.png'];
			}
			// debugger;
			// setProposal(negotiation.currentProposal);
			setItem(prev => ({
				...prev,
				...data,
				negotiation: { ...negotiation },
				images: imagesURL,
				garagePicturesA: garagePicturesA
			}));
			setLoading(false);
			// console.log(item);
			// debugger
		} catch (error) {
			console.log(error);
			throw error;
		}
	}


	useEffect(() => {
		getGarage();
	}, [negotiationID]);

	function fetchData() {
		axios.post(`${process.env.REACT_APP_API_URL}`, {
			action: 'Get_negotiations_meta',
			negotiation_id: negotiationID,
		})
			.then(response => {
				setMessagesList(response.data.data);
			})
			.catch(error => {
				console.log(error);
			});

		axios.post(`${process.env.REACT_APP_API_URL}`, {
			action: 'GetNegotiations_byID',
			id: negotiationID,
		})
			.then(response => {
				if (response.data.data.currentProposal !== proposalu) {
					setProposalUp(response.data.data.currentProposal);
				}

			})
			.catch(error => {
				console.log(error)
			});
	}

	useEffect(() => {
		if (negotiationID) {
			fetchData();
			const interval = setInterval(() => {
				fetchData();
			}, 5000);

			return () => clearInterval(interval);
		}
	}, [negotiationID]);

	useEffect(() => {
		if (item && item.negotiation) {
			if (item.negotiation.ownerID === userUID) {
				setDisabled(false)
				setAcceptButtonStyle("Secondary")
				console.log('setDisabled', 'false')
				// debugger
			} else {
				setDisabled(true)
				//setAcceptButtonStyle("Third")
				setAcceptButtonStyle("d-none")
				console.log('setDisabled', 'true')
			}
		}
	}, [item])



	return loading ? (
		<Loading text={"Loading Negotiation Details"} />
	) : (
		<div className="NegotiationsBarDetails_container">
			<span className="NegotiationsBarDetails_container_title">
				{item.negotiation.garageAddress}
			</span>
			<div className="NegotiationsBarDetails_container_garageDetail">
				<div className="NegotiationsBarDetails_container_garageDetail_img">
					<img src={`${item.images[0]}?time=${showTime}`}
						style={{ transform: `rotate(${item.garagePicturesA[0] ? item.garagePicturesA[0] : 0}deg)` }}
						alt="Garage_image" id="GarageImage" />
				</div>
				<div className="NegotiationsBarDetails_container_garageDetail_info">
					<div className="NegotiationsBarDetails_container_garageDetail_info_titles">
						Address: <br />
						Rental Rate: <br />
						Late Charge: <br />
						Bounce Fee:
					</div>
					<div className="NegotiationsBarDetails_container_garageDetail_info_user">
						{item.negotiation.garageAddress} <br />
						${item.rentalRate}<br />
						{item.lateCharge} <br />
						${item.bounceFee}
					</div>
				</div>
			</div>
			{item.negotiation.dealClosed || confirmed ? (
				<span className="strong">
					<strong>This negotiation has finished</strong>
					<span className="NegotiationsBarDetails_container_link" onClick={onClickSeeDetails}>
						See Details
					</span>
				</span>
			) : (
				<div className="NegotiationsBarDetails_container_actions">
					<button className="btn btn-primary " onClick={handleMakeCheckButton}>
						Check Garage
					</button>
					<button
						className={`btn btn-outline-success ${acceptButtonStyle}`}
						onClick={handleAcceptButton}
						disabled={disabled}
					>
						Accept Offer
					</button>
					<button className="btn btn-primary" onClick={handleMakeOfferButton}>
						Make a Proposal
					</button>
				</div>




			)}

			{disabled === false &&
				<div className="modal fade" id="pdfPreviewModalTwo" tabIndex="-1" role="dialog">
					<div className="modal-dialog modal-lg" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title">Accept Offer</h5>

								<button type="button" className="btn-close  close" data-dismiss="modal" aria-label="Close" onClick={closePDFTwoModal}>
									<span aria-hidden="true"></span>
								</button>
							</div>
							<div className="modal-body">
								<form onSubmit={handleSubmit(onSubmit)}>

									<div className="form-group row">
										<label className="form-label col-md-4" htmlFor="startdate"> Start Date:</label>
										<div className="col-md-8 d-flex position-relative">
											<Controller
												control={control}
												name="startdate"
												rules={{ required: true }}
												render={({ field }) => (
													<DatePicker
														selected={field.value}
														onChange={(date) => {
															field.onChange(date);
															handleChange();
														}}
														dateFormat="MM/dd/yyyy"
														placeholderText="MM/dd/yyyy"
														minDate={new Date()}
														showYearDropdown
														showMonthDropdown
														dropdownMode="select"
														className="form-control"
													/>
												)}
											/>
											{errors.startdate &&
												<span className="text-danger la la-exclamation-circle error-icon">
													<span className="badge badge-danger error-icon-text"> Start Date is required!</span>
												</span>
											}
										</div>
									</div>
									<div className="form-group row">
										<label className="form-label col-md-4" htmlFor="noofmonths"> Number of months:</label>
										<div className="col-md-8 d-flex position-relative">
											<Controller
												control={control}
												name="noofmonths"
												rules={{
													required: "Number of months is required",
													validate: (value) => {
														const intValue = parseInt(value);
														if (intValue <= 0) return "The value should be greater than 0";
														if (intValue > 36) return "The maximum value is 36";
														return true;
													},
												}}
												render={({ field }) => (
													<input
														type="number"
														minLength={2}
														className="form-control"
														onChange={(e) => {
															field.onChange(e);
															handleChange();
														}}

													/>

												)}
											/>

											{errors.noofmonths &&
												<span className="text-danger la la-exclamation-circle error-icon">
													<span className="badge badge-danger error-icon-text">{errors.noofmonths.message}</span>
												</span>
											}
										</div>
									</div>
									<div className="form-group text-center">
										{messageendDate}
									</div>
									<div className="form-group text-center">
										<button type="submit" className="btn btn-primary btn-lg" >Accpet</button>
									</div>

								</form>
							</div>
						</div>
					</div>
				</div>

			}
			<div className="NegotiationsBarDetails_container_Propusal">
				Current Proposal:
				<div className="NegotiationsBarDetails_container_Propusal_mount">
					${proposalu}
				</div>
			</div>
			<div className="NegotiationsBarDetails_container_conversationBox">
				<div className="NegotiationsBarDetails_container_conversationBox_messages outside">
					<NegotiationBarMessages messagesList={messagesList} key={item.negotiation.negotiationID} />
				</div>
				<div className="NegotiationsBarDetails_container_conversationBox_input">
					<form onSubmit={e => sendMessage(e)} >
						<input
							className="NegotiationsBarDetails_container_conversationBox_inputText"
							placeholder="Write a message..."
							value={message}
							onChange={e => handleInputChange(e)}
						/>
					</form>
					<span
						className={`search__map__toggle material-icons`}
						onClick={() => sendMessage()}
					>
						<i className="la la-paper-plane"></i>
					</span>
				</div>
			</div>
		</div>
	);
}

export default NegotiationsBarDetails;
